module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v5-scroller",
    attrs: {
      "id": _vm.containerId
    },
    on: {
      "touchstart": function($event) {
        return _vm.touchStart($event)
      },
      "touchmove": function($event) {
        return _vm.touchMove($event)
      },
      "touchend": function($event) {
        return _vm.touchEnd($event)
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f709500","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@58fe/v5/src/components/scroller/index.vue
// module id = 352
// module chunks = 0